import Swal from 'sweetalert2';
import { api } from '../../../api/api';
import { createActions, handleActions } from 'redux-actions'
import { goBack } from 'react-router-redux'
import { initialize as initializeForm } from 'redux-form'
import { push } from 'react-router-redux';

const url = 'clientes';

const LOADER_CLIENTE = 'LOADER_CLIENTE';
const SET_DATA_CLIENTE = 'SET_DATA_CLIENTE';
const SET_PAGE_CLIENTE = 'SET_PAGE_CLIENTE';
const SET_UPDATE_DATA_CLIENTE ='SET_UPDATE_DATA_CLIENTE';
const SET_BUSCADOR_CLIENTE = 'SET_BUSCADOR_CLIENTE';
const SET_FILTRO_CLIENTE = 'SET_FILTRO_CLIENTE';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_CLIENTE, cargando: true});
    const store = getStore();
    const search = store.clientes.buscador;
    const filtro = store.clientes.filtro_cliente;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_CLIENTE, cargando: false});
        Swal(
            'Error',
            (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_CLIENTE, data});
            dispatch({type: SET_PAGE_CLIENTE, page});
        }
        dispatch({type: LOADER_CLIENTE, cargando: false});
    })
};
const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_CLIENTE, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_CLIENTE, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/admin_clientes'))
        }
    }).then((data) => {
        dispatch({type: LOADER_CLIENTE, cargando: false});
        if(data){
            dispatch({type: SET_UPDATE_DATA_CLIENTE, updateData: data});
            dispatch(initializeForm('cliente', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.cliente.values;
    dispatch({type: LOADER_CLIENTE, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_CLIENTE, cargando: false})
        Swal('Éxito', 'Se ha creado el cliente.', 'success')
        .then(() => {
            dispatch(push('/admin_clientes'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_CLIENTE, cargando: false})
        Swal(
            'Error',
             (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_CLIENTE, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.cliente.values);
    dispatch({type: LOADER_CLIENTE, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_CLIENTE, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/admin_clientes'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_CLIENTE, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/admin_clientes'));
        }
    })
}
const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_CLIENTE, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_CLIENTE, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
        })
    }).then((data) => {
        dispatch({type: LOADER_CLIENTE, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_CLIENTE, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_CLIENTE, filtro_cliente: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_CLIENTE]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_CLIENTE]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_CLIENTE]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_CLIENTE]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_CLIENTE]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_CLIENTE]: (state, { filtro_cliente }) => {
        return {...state, filtro_cliente }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_cliente: null,
    updateData: {},
};
export default handleActions(reducer, initialState)
